import { getUrl, Request } from "../../request";

export const getUserBills = () => {
  return Request.get(getUrl("/api/v1/service_center/user-bills/"));
};

export const getUserBill = (code) => {
  return Request.get(getUrl("/api/v1/service_center/bill-factor/"), {
    code,
  });
};

export const getServiceCenters = (type_id, city_id) => {
  return Request.get(getUrl("/api/v1/service_center/"), {
    type_id,
    city_id,
  });
};

export const getServiceCenterTypes = (city_id) => {
  return Request.get(getUrl("/api/v1/service_center/types/"), {
    city_id,
  });
};
